import { Component } from '@angular/core'

@Component({
  selector: 'lin-table-toolbar',
  template: ` <ng-content></ng-content> `,
  styleUrls: ['./table-toolbar.component.scss'],
  standalone: false,
})
export class TableToolbarComponent {}
